import script from "./LookupForm.vue?vue&type=script&setup=true&lang=js"
export * from "./LookupForm.vue?vue&type=script&setup=true&lang=js"

import "./LookupForm.vue?vue&type=style&index=0&id=1a84f169&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a84f169"]])

export default __exports__